module.exports = __webpack_public_path__ + "static/media/club_full.27e8fbbb.jpg";